"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTooltipPopoverText = exports.StyledTooltipPopoverInnerIcon = exports.StyledTooltipPopover = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../../../helpers");
const Icon_1 = require("../../../Icon");
const StackView_1 = require("../../../StackView");
const Text_1 = require("../../../Text");
exports.StyledTooltipPopover = (0, styled_components_1.default)(StackView_1.StackView) `
    display: inline-flex;
    box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.25);
    background: #fff;

    ${({ maxWidth, theme }) => (0, styled_components_1.css) `
        padding: ${theme.spacing.s};
        border: ${helpers_1.BASE_BORDER_WIDTH} solid ${theme.colorBorderMain};
        max-width: ${maxWidth || theme.sizes.fields.m};
    `}
`;
exports.StyledTooltipPopoverInnerIcon = (0, styled_components_1.default)(Icon_1.Icon) `
    height: 14px;
    width: 14px;
    margin-top: -1px;
`;
exports.StyledTooltipPopoverText = (0, styled_components_1.default)(Text_1.Text) `
    word-break: break-word;
    overflow: hidden;
`;
//# sourceMappingURL=TooltipPopover.styles.js.map